import { Col } from "antd";
import { Icons } from "../assets/icons";
import PageHeader from "../components/ui/PageHeader";
import { ICON_SIZE } from "../repository/data.default";
import FooterQuoteCard from "../components/ui/FooterQuoteCard";
import SatageSubHeader from "../components/ui/SatageSubHeader";
import SectionOne from "../components/AwarnessSections/SectionOne";

const footerText = (
  <p>
    Leadership is crucial in fostering a healthy work environment by driving
    wellbeing policies, motivating managers to implement them, and setting
    objectives for continuous improvement. By promoting a culture of respect,
    care, and cooperation, leaders enhance psychological safety and engage
    employees to address workplace risk factors and identify areas for growth.
    Research shows that effective wellbeing programs can reduce absenteeism by
    30% and boost productivity by 20%, underscoring the importance of leadership
    in this area.
  </p>
);

const stepsList = (
  <>
    <li>a. Problem recognition (Assessment)</li>
    <li>b. Identify key issues or patterns</li>
    <li>c. Conduct an organizational review</li>
    <li>d. Identify organizational readiness and audit</li>
    <li>e. Assign the 360 Risk Assessment to employees</li>
  </>
);
const overviewText = (
  <p>
    Welcome to the Awareness Stage. This stage is designed to help you identify
    and address the key challenges affecting employee well-being and
    organizational performance. Follow the steps below to navigate and complete
    this stage effectively.
  </p>
);

function AwarenessPage() {
  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      {/* Header */}
      <PageHeader
        stage={1}
        title={"AWARNESS STAGE"}
        icon={<Icons.AwarnessStageIcon width={ICON_SIZE} height={ICON_SIZE} />}
      />
      {/* Sub Header  */}
      <SatageSubHeader overviewText={overviewText} stepsList={stepsList} />

      {/* Steps Section */}
      <SectionOne />

      {/* Footer */}
      <FooterQuoteCard
        icon={<Icons.AwarnessFooterIcon width={350} height={350} />}
        text={footerText}
      />
    </Col>
  );
}

export default AwarenessPage;
